// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".html-style{width:100%;font-size:54px;-webkit-text-size-adjust:100%}.body-style,.html-style{min-width:10rem!important;background-color:#f5f7fa}.body-style{width:10rem!important;margin:0 auto!important;position:relative;overflow-x:hidden;overflow-y:auto;padding-top:1.28rem}.body-style #bigolive{font-size:.21333rem}", ""]);
// Exports
module.exports = exports;
